<template>
  <el-menu class="navbar" mode="horizontal">
    <div class="logo">
      <span style="font-size:18px;line-height: 40px;">内在美管理系统</span>
    </div>
    <hamburger class="hamburger-container" :toggleClick="toggleSideBar" :isActive="sidebar.opened"></hamburger>
    
    <div class="navbar-right">
      <div v-if="userType === 20" class="store-indicator">
        <el-icon class="el-icon-map-marker store-icon"><el-icon-map-marker /></el-icon>
        <span class="store-label">当前门店：</span>
        <span class="store-name">{{ currentStoreName || '未选择' }}</span>
      </div>

      <div class="notification-container" @click="goToMessages">
        <el-badge :value="unreadCount > 0 ? (unreadCount > 99 ? '99+' : unreadCount) : undefined" class="notification-badge">
          <el-icon class="el-icon-bell notification-icon"><el-icon-bell /></el-icon>
        </el-badge>
      </div>

      <el-dropdown class="avatar-container" @command="handleCommand" trigger="click">
        <div class="avatar-wrapper">
          欢迎您，{{name}}
          <el-icon class="el-icon-caret-bottom"><el-icon-caret-bottom /></el-icon>
        </div>
        <template #dropdown><el-dropdown-menu class="user-dropdown">
          <el-dropdown-item command="handleGoProfile">
            <span>个人中心</span>
          </el-dropdown-item>
          <el-dropdown-item>
            <span>切换主题
              <el-switch :active-value="1" :inactive-value="0" style="margin-left: 5px;" v-model="theme" />
            </span>
          </el-dropdown-item>
          <el-dropdown-item command="logout" divided>
            <span>退出</span>
          </el-dropdown-item>
        </el-dropdown-menu></template>
      </el-dropdown>
    </div>
  </el-menu>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import Hamburger from '@/components/Hamburger'
import logo from '@/assets/logo.png?imageView2/1/w/80/h/80'
import * as signalR from '@microsoft/signalr'
import * as storeApi from '@/api/store/store'
import * as messageApi from '@/api/sys/sysmessages'

export default {
  data: function () {
    return {
      logo: logo,
      theme: 0,
      storeList: [],
      unreadCount: 0,
      hubConnection: null,
    }
  },
  components: {
    Hamburger,
  },
  computed: {
    ...mapGetters(['sidebar', 'name', 'themeStatus', 'userType', 'lastStoreId', 'token']),
    currentStoreName() {
      const store = this.storeList.find(s => s.id === this.lastStoreId)
      return store ? store.storeName : ''
    },
  },
  watch: {
    theme() {
      this.toggleClass(document.body, 'custom-theme')
    },
    lastStoreId() {
      if (this.userType === 20 && this.storeList.length === 0) {
        this.loadStoreList()
      }
    },
  },
  mounted() {
    this.theme = Number(this.themeStatus)
    this.toggleClass(document.body, 'custom-theme')
    if (this.userType === 20) {
      this.loadStoreList()
    }
    this.loadUnreadCount()
    this.initHubConnection()
  },
  beforeUnmount() {
    if (this.hubConnection) {
      this.hubConnection.stop().catch(() => {})
    }
  },
  methods: {
    ...mapActions(['signOutOidc', 'saveTheme']),
    loadStoreList() {
      storeApi.listByWhere({ limit: 1000 }).then(res => {
        if (res && res.code === 200) {
          this.storeList = res.result || []
        }
      }).catch(() => {
        this.storeList = []
      })
    },
    loadUnreadCount() {
      messageApi.getList({ page: 1, limit: 20, status: -10,type: 20 }).then(res => {
        if (res && res.code === 200) {
          this.unreadCount = res.result.length || 0
        }
      }).catch(() => {
        this.unreadCount = 0
      })
    },
    initHubConnection() {
      const hubUrl = process.env.VUE_APP_HUB_URL || window.location.origin
      this.hubConnection = new signalR.HubConnectionBuilder()
        .withAutomaticReconnect()
        .withUrl(`${hubUrl}/ServerHub`, { accessTokenFactory: () => this.token })
        .build()

      this.hubConnection.on('NewMessage', (data) => {
        if (data && data.UnreadCount) {
          this.unreadCount += data.UnreadCount
        }
      })

      this.hubConnection.on('ConnectResponse', (data) => {
        if (data && data.code === 200) {
          console.log('SignalR 连接成功')
        }
      })

      this.hubConnection.start().catch(err => {
        console.error('SignalR 连接失败:', err)
        setTimeout(() => this.initHubConnection(), 5000)
      })
    },
    goToMessages() {
      this.$router.push('/sys/SysMessages/Index')
    },
    toggleClass(element, className) {
      if (!element || !className) {
        return
      }
      let classString = element.className
      const nameIndex = classString.indexOf(className)
      if (nameIndex === -1) {
        classString += '' + className
      } else if (this.theme !== 1) {
        classString =
          classString.substr(0, nameIndex) +
          classString.substr(nameIndex + className.length)
      }
      element.className = this.theme === 1 ? classString : ''
      console.log("theme", this.theme)
      this.saveTheme(this.theme)
    },
    toggleSideBar() {
      this.$store.dispatch('ToggleSideBar')
    },
    logout() {
      this.$store.dispatch('LogOut').then(() => {
        location.reload() // 为了重新实例化vue-router对象 避免bug
      })
    },
    handleGoProfile() {
      this.$router.push('/profile')
    },
    handleCommand(name) {
      if (!name) return
      this[name]()
    },
  },
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.navbar-right {
  position: absolute;
  right: 35px;
  top: 0;
  height: 55px;
  display: flex;
  align-items: center;
  gap: 20px;
}
/* 覆盖全局 .navbar .avatar-container 的绝对定位，改为随右侧栏流式排列 */
.navbar-right .avatar-container {
  position: static;
  right: auto;
  height: 55px;
  line-height: 55px;
}
.store-indicator {
  display: flex;
  align-items: center;
  background: #ffffff;
  border: 1px solid #e4e7ed;
  border-radius: 20px;
  padding: 0 16px;
  height: 34px;
  line-height: 1;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}
.store-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 14px;
  height: 100%;
  line-height: 1;
  color: #1890ff;
  font-size: 14px;
  margin-right: 6px;
}
.store-icon :deep(svg) {
  display: block;
}
.store-label {
  color: #1890ff;
  font-size: 13px;
  margin-right: 4px;
}
.store-name {
  color: #1890ff;
  font-size: 13px;
  min-width: 100px;
}
.notification-container {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 40px;
  line-height: 1;
  cursor: pointer;
  padding: 0 12px;
  border-radius: 4px;
  transition: background-color 0.2s;
}
.notification-container:hover {
  background: rgba(255, 255, 255, 0.1);
}
.notification-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  line-height: 1;
  color: #fff;
}
.notification-badge {
  --el-badge-font-size: 11px;
  display: flex;
  align-items: center;
  line-height: 1;
}
.notification-badge :deep(.el-badge__content) {
  min-width: 18px;
  height: 18px;
  line-height: 18px;
  font-size: 11px;
  padding: 0 5px;
  border-radius: 9px;
  background: #f56c6c;
  color: #ffffff;
}
</style>
